import {useEffect} from 'react';
import {Platform} from 'react-native';
import {useDispatch} from 'react-redux';
import {showLoader, hideLoader} from '@shared/store/loaderSlice';

/**
 * Dispatches showLoader / hideLoader on Android whenever `isSubmitting` changes.
 * On other platforms the modal renders its own <LoaderOverlay>, so this is a no-op.
 *
 * Extracted to eliminate the identical useEffect that existed in both
 * ChangeRepairReasonModal and ChangeWOStatusModal.
 */
const useSubmittingLoader = (isSubmitting: boolean): void => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (Platform.OS !== 'android') return;
    if (isSubmitting) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isSubmitting, dispatch]);
};

export default useSubmittingLoader;

/** Shared orientations array used by both status-change modals. */
export const MODAL_SUPPORTED_ORIENTATIONS: Array<
  'portrait' | 'landscape' | 'landscape-left' | 'landscape-right'
> = ['portrait', 'landscape', 'landscape-left', 'landscape-right'];

/** Shared FlatList columnWrapperStyle used by both status-change modals. */
export const STATUS_COLUMN_WRAPPER_STYLE = {
  justifyContent: 'space-between' as const,
  marginBottom: 24,
} as const;